import { render, staticRenderFns } from "./PatientsForCaller.vue?vue&type=template&id=f2e1a060&scoped=true&"
import script from "./PatientsForCaller.vue?vue&type=script&lang=js&"
export * from "./PatientsForCaller.vue?vue&type=script&lang=js&"
import style0 from "./PatientsForCaller.vue?vue&type=style&index=0&id=f2e1a060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e1a060",
  null
  
)

export default component.exports